import React from 'react';

export const KeyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.00014 7.33332C3.34329 7.33332 2.00014 8.67647 2.00014 10.3333C2.00014 11.9902 3.34329 13.3333 5.00014 13.3333C6.657 13.3333 8.00014 11.9902 8.00014 10.3333C8.00014 8.67647 6.657 7.33332 5.00014 7.33332ZM0.666809 10.3333C0.666809 7.94009 2.60691 5.99999 5.00014 5.99999C7.39338 5.99999 9.33347 7.94009 9.33347 10.3333C9.33347 12.7266 7.39338 14.6667 5.00014 14.6667C2.60691 14.6667 0.666809 12.7266 0.666809 10.3333Z"
      fill="var(--color-text-primary-alt)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4715 0.861919C14.7319 1.12227 14.7319 1.54438 14.4715 1.80473L8.07155 8.20473C7.8112 8.46508 7.38909 8.46508 7.12874 8.20473C6.86839 7.94438 6.86839 7.52227 7.12874 7.26192L13.5287 0.861919C13.7891 0.601569 14.2112 0.601569 14.4715 0.861919Z"
      fill="var(--color-text-primary-alt)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1954 2.19525C12.4558 1.9349 12.8779 1.9349 13.1382 2.19525L15.1382 4.19525C15.3986 4.4556 15.3986 4.87771 15.1382 5.13806L12.8049 7.47139C12.5445 7.73174 12.1224 7.73174 11.8621 7.47139L9.86207 5.47139C9.60172 5.21104 9.60172 4.78893 9.86207 4.52859C10.1224 4.26824 10.5445 4.26824 10.8049 4.52859L12.3335 6.05718L13.724 4.66666L12.1954 3.13806C11.9351 2.87771 11.9351 2.4556 12.1954 2.19525Z"
      fill="var(--color-text-primary-alt)"
    />
  </svg>
);
